export enum PodType {
    BTUsoDomestico = 0,
    BTIlluminazionePubblica = 1,
    BTAltriUsi = 2,
    MTIlluminazionePubblica = 3,
    MTAltriUsi = 4,
    ATFinoA150kv = 5,
    AATFinoA380kv = 6,
    BTVeicoliElettrici = 7,
    ATFinoA220kv = 8,
    AATOltre380kv = 9,
    BTUsoDomesticoPompeCalore = 10
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/podType.enum.ts